/**
 * Handle attempts to access data that requires a login (redirects the user
 * to the login page, with a URL set so that they can return)
 */
import {useLocation} from "react-router-dom-v5-compat";

import FullPageSpinner from "@repo/component-screens/full-page-spinner";
import {getLoginUrl, redirect} from "@repo/urls";

export default function LoginRequired() {
    const {pathname, search, hash} = useLocation();
    const continueUrl = pathname + search + hash;
    const url = getLoginUrl(continueUrl);
    redirect(url);
    return <FullPageSpinner />;
}
